import rpmenu from "../../assets/images/reponsive_menu.svg"
function MobileHumberger ({toggleSideBar}) {

    
    return  (<div className="moble_menu_icon" >
                <img src={rpmenu} alt="" onClick={() => toggleSideBar() } /> 
            </div>)

}


export default MobileHumberger